import React from 'react';
import BookmarkBorderIcon from 'material-ui-icons/BookmarkBorder';
import BookmarkIcon from 'material-ui-icons/Bookmark';
import AddIcon from 'material-ui-icons/Add';
import Button from '../../components/Buttons';

export default function BookTileFooter(props) {
        return  <div className="bookTile__card--right--footer" style={{height: props.height + 'px'}}>
                    <div className="bookTile__card--bookmarkIcon">
                        {props.isInReadList? '' :
                            <Button onClick={() => props.clickHandler('bookMark')}>
                                {props.isInWatchList? <BookmarkIcon/> : <BookmarkBorderIcon/>}
                                <span aria-label={props.isInWatchList? "Book saved" : "Book unsaved"}
                                      className="bookTile__bookMark--text">{props.isInWatchList? 'Saved' : 'Save'}</span>
                            </Button>
                        }
                    </div>
                    <div className={(props.isInReadList? "button--withoutBorder" : "") + " bookTile__card--button" }>
                        <Button onClick={() => props.clickHandler('readMark')}>
                            <span>{props.isInReadList? null : <AddIcon className='bookTile__footer--addIcon'></AddIcon>}</span>
                            <span>{props.isInReadList? 'Remove from Reading Log' : 'Add to Reading Log'}</span>
                        </Button>
                    </div>
                </div>
}
